var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.checkIfVisible())?_c('b-link',{staticClass:"custom pb-2",attrs:{"title":_vm.$t('usuń')},on:{"click":function($event){$event.preventDefault();return _vm.deleteElement(_vm.itemId)}}},[_c('span',{staticClass:"icon icon-delete"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }